/// <reference path="../../app.definition.ts" />

/*
* eCareVault.IDocumentService
* author: Kapil Jethava
*/
import angular from "angular";
import { LoggingDetail } from "@common/model/loggingDetail";
import { saveAs } from 'file-saver';
import _ from "lodash";
import { FOLDER_MODULES } from "@common/model/constants";
import { PostTypeEnums } from "../model/_adocument";
import { feedTypeOfDocument, ICachingService } from "./caching.service";
import { IPdfViewerService } from "@/app/library/PdfViewer/service/pdfViewer.service";
import { JavaApiAdapterService } from "../apiadapter/javaapi.service";
import { CommonService } from "../common.service";
import { PopUpService } from "../popup/popup.service";
import { CacheService } from "./cache.service";
import { ILoggingService } from "./logging.service";
import { IUtilityService } from "./util.service";
    export interface IDocumentService {
        getDocumentLink(post: { documentId: any; isConvertedPdf: boolean; downloadSignedCopy: boolean; permissionType: string; filename: string; title: any; keywords: string; }): void;
        getDocumentContent(documentId: number, isConvertedPdf: boolean, downloadSignedCopy?: boolean, signing?: boolean): ng.IPromise<any>;
        updateDocumentData(post, data, updateMetadata);
        getCoverSheetContent(fileName: string, bucketName: string): any;
        updateDocumentUsers(subjectId, user, documents);
        updateDocState(documents, subjectId, action, type);
        updateEntityViewed(entityType, entityId, noApi?: boolean): void;
    }

    export class DocumentService implements IDocumentService {
        svcName: string = 'AppStateService';
        logDetail: LoggingDetail;

        getDocumentContent(documentId, isConvertedPdf: boolean, downloadSignedCopy?: boolean, signing?: boolean): ng.IPromise<any> {
            const deferred = this.$q.defer();
            const context = this;
            this.$_api.getDocumentLink(
                documentId,
                this.$_cache.getPassword(),
                'DOCUMENT',
                isConvertedPdf,
                !!downloadSignedCopy,
                !!signing,
                true).then((s) => {
                        try {
                            var events = this.$_log.events;
                            var user = context.$_cache.getUser();
                            var sasData = this.$_cache.getSASSToken();
                            var blobUri = `${this.storageConfig.url}/${s.bucketName}/${user.providerIdentity}/${s.fileName}?${sasData.sasToken}`;
                            var startTime = Date.now();
                            var req = new XMLHttpRequest();
                            req.open("GET", blobUri, true);
                            req.responseType = "arraybuffer";
                            req.onerror = function (evt) {
                                context.logDetail = new LoggingDetail(events.DOWNLOAD_DOC, documentId, startTime, Date.now(), false);
                                context.$_log.logAction(context.logDetail);
                                console.log(req.response);
                                deferred.reject(req.response);
                                return;
                            };
                            req.onload = function (evt) {
                                context.logDetail = new LoggingDetail(events.DOWNLOAD_DOC, documentId, startTime, Date.now(), true);
                                context.$_log.logAction(context.logDetail);
                                var content = req.response;
                                if (downloadSignedCopy) {
                                    //in case of signed copy it will also provide the list of signatures
                                    deferred.resolve({ content, groups: s.groups, objects: s.objects || [] })
                                } else {
                                    deferred.resolve(content);
                                }
                            }
                            req.send();
                        } catch (e) {
                            console.error(e);
                        }
                }, (e) => {
                    console.log(e);
                    deferred.reject(e);
                });
            return deferred.promise;
        }

        updateDocumentData(post, data, updateMetadata) {
            let keys = Object.keys(data);
            let result;
            if (!Array.isArray(post)) {
                result = [post];
            } else {
                result = post;
            }
            result.forEach((p) => {
                keys.forEach((param) => {
                    p[param] = data[param];
                })
                this.BroadcastService.broadcast('update-context-menu', [p.id]);
                this.BroadcastService.broadcast('update-document-signature-status',[p.id]);
                this.BroadcastService.broadcast('update-signature-badge', [p.id, p.signStatus]);
            })


            if (updateMetadata) {
                this.$_caching.addOrUpdateDocuments(result);
            }

        }

        updateDocState(documents, subjectId, action, type = null){
            var filteredPost = documents.filter(p => p.subjectId == subjectId);
            if (!!filteredPost) {
                let data = {};
                this.$_subject.getSubjectById(subjectId).then(sub => {
                    if (_.includes(['JOINED', 'CO-CAPTAIN'], action)) {
                        data = {
                            subject: sub
                        }
                        this.updateDocumentData(filteredPost, data, false);
                    } else if (action == 'EXIT') {
                        data = {
                            permissionEndDate: new Date().getTime(),
                            subject: sub
                        }
                        this.updateDocumentData(filteredPost, data, true);
                    }

                    if (!!type) {
                        var cachedFeeds = this.$_caching.getCachedFeeds();
                        cachedFeeds[type] = documents;
                        this.$_caching.saveCachedFeeds(cachedFeeds);
                    }
                });
            }
        }

        //Updates the former status of document users.
        updateDocumentUsers(subjectId, user, documents) {
            var filteredPost = documents.filter(p => p.subjectId == subjectId);
            if (!!filteredPost) {
                this.$_post.updatePostUserFormerStatus(filteredPost, user);
            }
        }

        getCoverSheetContent(fileName: string, bucketName: string): any {
            const deferred = this.$q.defer();
            var getCoverSheetContentData = (fileName: string, bucketName: string, sasToken: string) => {
                try {
                    let pdfUrl = `${this.storageConfig.url}/${bucketName}/${fileName}?${sasToken}`;
                    var req = new XMLHttpRequest();
                    req.open("GET", pdfUrl, true);
                    req.responseType = "blob";
                    req.onerror = function (evt) {
                        console.log(req.response);
                        deferred.reject(req.response);
                        return;
                    };
                    req.onload = function (evt) {
                        deferred.resolve(req.response);
                    }
                    req.send();
                } catch (e) {
                    console.error(e);
                }
            };
            const sassObject = this.$_cache.getSASSToken();
            if (!!sassObject && !!sassObject.expiryTime && sassObject.expiryTime > new Date().toISOString()) {
                getCoverSheetContentData(fileName, bucketName, sassObject.sasToken);
            } else {
                this.$_api.getSASSToken().then((token) => {
                    this.$_cache.setSASSToken(token);
                    getCoverSheetContentData(fileName, bucketName, token.sasToken);
                });
            }
            return deferred.promise;
        }

        downloadCvrSheet = (fileName, bucketName) => {
            var deferred = this.$q.defer();
            this.$rootScope.mainShowLoader = true;
            this.getCoverSheetContent(fileName, bucketName).then((content) => {
                try {
                    saveAs(content, fileName);
                } catch (e) {
                    (window.navigator as any).msSaveBlob(content, fileName);
                }
                this.$rootScope.mainShowLoader = false;
                deferred.resolve();
            },
                (e) => {
                    this.$rootScope.mainShowLoader = false;
                    console.log("Error while downloading cover sheet:: ", e);
                    deferred.reject();
                });
            return deferred.promise;
        }

        isPostShareable = (item, sub, crntUserId) => {
            if (item.permissionEndDate) {
                return false;
              }

              if (sub && sub.isFrozen) {
                return false;
              }

              if (!item.permissionType || item.permissionType === "OWN") {
                return true;
              }

              if (item.permissionType === "ACCESS" && ((sub && sub.isActiveMember && (sub.coCaptain || sub.ownerId === crntUserId)))) {
                return true;
              }

              //enable the share icon for both document and video type document
              if (_.includes([PostTypeEnums.DOCUMENT , PostTypeEnums.LINK], item.postType) && item.userPerm && item.userPerm.share) {
                return true;
              }

              return false;
        }

        getRestrictedSharingMsg = (sub, item, dispAs, crntUserId) => {
            let msg = "";
            let vo = item.permissionType == "VIEW";
            if (dispAs == 'form') {
                vo = !item.userCanShare(crntUserId);
            }
            if (sub.isFormerTeamMember) {
                msg = "You must be an active Team Member to share with the Team.";
            } else if (sub.isFrozen) {
                msg = "A Team must be active to share with Team Members.";
            } else if (!!item.permissionEndDate) {
                msg = "You can't share this " + dispAs + " because you do not have access to the latest version.  Please ask a Team Member to re-share the " + dispAs + " with you.";
            } else if (vo) {
                msg = "You have View Only access to this " + dispAs + " and cannot share it";
            } else {
                msg = "Only a Captain or Co-captain can share a " + dispAs + " that has been shared with them.";
            }
            return msg;
        }

        getNotViewedCnt = (postType, subjectId) => {
            let count = 0;
            if(!!subjectId){
                const feedType = feedTypeOfDocument(postType);
                var cachedDocuments = this.$_caching.getCachedFeeds()[feedType];
                let notViewedDocs = cachedDocuments.filter((d) => {
                    return (d.subjectId == subjectId && !d.viewed);
                })
                count = notViewedDocs.length;
            } else {
                let cnt = this.$_cache.getNotViewedCount();
                count = cnt[postType];
            }
            return count;

        }

        /**
         * To update the notViewedCount for documents and discussions
         * @param entityType The type of entity for which the count has to be updated (DOCUMENT/DISCUSSION)
         * @param entityId Id of the entity to be updated. This is passed when an action on any entity is taken or when single notification is clicked.
         * @param noApi Whether the api should be called. In case of single notification click or click of notifications Clear All, backend will handle the updation and so no need to call the api.
         */
        updateEntityViewed = (entityType, entityId?, noApi?) => {
            let user = this.$_cache.getUser();
            if (!!user && user.organizationId == 0) {
                let cnt = this.$_cache.getNotViewedCount();
                //If notViewedCount > 0 for the entityType, only then go ahead
                if (!!cnt && ((!!entityType && cnt[entityType] > 0) ||
                    (!entityType && !Object.keys(cnt).every((k) => cnt[k] == 0)))) {
                    const feedType = feedTypeOfDocument(entityType);
                    var payload = {};
                    var cachedDocuments = this.$_caching.getCachedFeeds();
                    if (!!entityId) {
                        cachedDocuments[feedType].forEach((d) => {
                            if (d.id == entityId && !d.viewed) {
                                d.viewed = true;
                                cnt[entityType]--;
                                payload['id'] = entityId;
                                payload['postType'] = entityType;
                            }
                        });
                    } else if (!!entityType) {
                        cnt[entityType] = 0;
                        cachedDocuments[feedType].forEach((d) => {
                            if (d.postType == entityType && !d.viewed) {
                                d.viewed = true;
                            }
                        });
                        payload['postType'] = entityType;
                    } else {
                        cnt[FOLDER_MODULES.DOCUMENT] = 0;
                        cnt[FOLDER_MODULES.DISCUSSION] = 0;
                        cachedDocuments['documents'].forEach((d) => {
                            if (!d.viewed) {
                                d.viewed = true;
                            }
                        });
                        cachedDocuments['discussions'].forEach((d) => {
                            if (!d.viewed) {
                                d.viewed = true;
                            }
                        });
                    }
                    this.$_cache.setNotViewedCount(cnt);
                    this.$_caching.saveCachedFeeds(cachedDocuments);
                    this.BroadcastService.broadcast('viewed-count-updated');
                    if (!noApi) {
                        let loggedInUser = this.$_cache.getUser();
                        this.$_api.updateViewedFlag(loggedInUser.id, payload);
                    }
                }
            }
        }

        SubScribeTopPosition(leftPanel , rightPanel, scrollCnt){
            setTimeout(() => {
                // Get the relative and fixed divs
                const relativeDiv = document.getElementById(leftPanel);
                const fixedDiv = document.getElementById(rightPanel);
                // Calculate the position of the relative div relative to the viewport
                if (relativeDiv && fixedDiv) {
                    if($(scrollCnt).length > 0) {
                        $(scrollCnt).scrollTop(0);
                    }
                    // Calculate the position of the relative div relative to the viewport
                    const relativeDivRect = relativeDiv.getBoundingClientRect();
                    const relativeDivTop = relativeDivRect.top;
                    // Set the position of the fixed div beside the relative div
                    fixedDiv.style.top = `${relativeDivTop}px`;
                    //Set height of right panel
                    let scrl: HTMLElement = document.querySelector('#rightPanel .right-panel-scroll');
                    if(scrl){
                        const hgt = window.innerHeight - relativeDivTop - 10;
                        scrl.style.height = `${hgt}px`;
                    }
                }
            }, 0);
        }

        getDocumentLink = (post) => {
            this.$rootScope.mainShowLoader = true;

            this.getDocumentContent(post.documentId, post.isConvertedPdf, post.downloadSignedCopy)
            .then((data) => {
                var content = (post.downloadSignedCopy ? data.content : data);
                if (!!post.isConvertedPdf) {
                    // Open the PDF immediately
                    this.$_pdfViewerSvc.loadPdf({ data: content }, (post.permissionType == 'ACCESS' || post.permissionType == 'OWN'));
                } else {
                    // Download the document immediately
                    this.$_com.downloadDocument(this.$_util.getTitleWthExt(post), post.keywords, content);
                }

            })
            .catch((error) => {
                this.$_pop.openInformationModal(error);
            })
            .finally(() => {
                this.$rootScope.mainShowLoader = false;
            });
        }

        static $inject = ['$q', 'CacheService', 'CachingService', 'UtilityService', 'ApiAdapterService', '$rootScope', '$timeout',
            'CommonService', 'SubjectService', 'PostService', 'LoggingService', 'BroadcastService', 'SnackbarService', 'authConfig',
            'storageConfig', "PdfViewerService", "$sce",  "PopUpService", "CommonService","PermissionService"];
        constructor(
            private $q,
            private $_cache: CacheService,
            private $_caching: ICachingService,
            private $_util: IUtilityService,
            private $_api: JavaApiAdapterService,
            private $rootScope,
            private $timeout: ng.ITimeoutService,
            private $_comService: CommonService,
            private $_subject,
            private $_post,
            private $_log: ILoggingService,
            private BroadcastService,
            private $_snack,
            private authConfig,
            private storageConfig,
            private $_pdfViewerSvc: IPdfViewerService,
            private $sce,
            private $_pop: PopUpService,
            private $_com: CommonService
        ) {
        }
    }

angular.module('eCareVault.common.services')
    .service('DocumentService', DocumentService);
